import { MessageService } from 'src/app/services/message.service';
import {
  Component,
  OnInit,
} from '@angular/core';
import { Ship } from '../../Ship';
import { ShipService } from '../../services/ship.service';
import { Router } from '@angular/router';
import { Merchant } from '../../Merchant';
import { EntitlementService } from '../../services/entitlement.service';
import { UntypedFormControl, UntypedFormGroup, NgForm, Validators } from '@angular/forms';
import { SFAValidator } from '../../validators/ship-validator';
import { MerchantService } from 'src/app/services/merchant.service';

@Component({
  selector: 'app-ship-merchants',
  templateUrl: './ship-merchants.component.html',
  styleUrls: ['./ship-merchants.component.css']
})
export class ShipMerchantsComponent implements OnInit {
  ship: Ship;
  shipResultArray: Ship[];
  shipMerchantArray: Merchant[];
  stripActionStatus: string;
  merchantDetailForm: UntypedFormGroup;
  stripActionSuccessFail = '';
  stripActionCircle = '';
  stripCircleCheck = '';
  save_m_btn = false;
  save_m_btn_spinner = '';

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private router: Router,
    private merchantService: MerchantService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.ship = this.shipService.retrieveShipProfile();
    this.shipResultArray = this.shipService.retieveAllShipProfileResults();
    if (this.ship == null) {
      this.router.navigate(['/shipProfiles']);
    }
    this.shipService.getMerchantsByShip(this.ship.shipLocation).subscribe(
      (data: Merchant[]) => {
        this.shipMerchantArray = data;
      },
      error => {
        console.log('There was an error ' + error);
      },
      () => { }
    );
    this.initForm();
  }

  initForm() {
    this.merchantDetailForm = new UntypedFormGroup({
      sfaNumber: new UntypedFormControl(this.ship.sfaNum, [
        Validators.required,
        SFAValidator
      ])
    });
    this.merchantDetailForm.statusChanges.subscribe((newStatus: string) => {
      this.save_m_btn = newStatus === 'INVALID';
    });
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  onShipChange(newShip: Ship) {
    this.ship = newShip;
    this.shipService.getMerchantsByShip(this.ship.shipLocation).subscribe(
      (data: Merchant[]) => {
        this.shipMerchantArray = data;
      },
      error => {
        console.log('There was an error ');
      }
    );
  }

  updateMerchantSFA() {
    this.save_m_btn_spinner = 'fa fa-spinner fa-spin';
    this.save_m_btn = true;

    this.shipService
      .postSFANumber(
        this.ship.shipLocation,
        this.merchantDetailForm.value['sfaNumber']
      )
      .subscribe(
        (newShip: Ship) => {
          this.ship = newShip;
          this.messageService.success('Updated Successfully');
          this.ship = newShip;
          this.shipService.storeShipProfile(this.ship);
        },
        error => {
          this.messageService.error(error.message);
        },
        () => {
          this.save_m_btn_spinner = '';
          this.save_m_btn = false;
        }
      );
  }

  gotoMerchantsTab(merchant: Merchant) {
    this.merchantService.getMerchantData(merchant.ncMerchantNum, this.ship.shipLocation).subscribe(data => {
      const merch: Merchant = {
        cardNum: data.cardList[0].masterCard,
        descriptionLong: data.merchant.descriptionLong,
        location: data.merchant.location,
        ncMerchantNum: data.merchant.ncMerchantNum,
        shipName: this.ship.shipName,
        type: data.merchant.merchantType
      };
      this.merchantService.selectMerchant(merch);
      this.merchantService.storeRecentMerchant(merch);
      this.router.navigate(['/merchantProfiles/accounts']);
    });
  }
}
